import { useNavigate, useLocation } from "react-router-dom";

// Навигация к секциям по id: скролл, если на главной; иначе переход на / + скролл.
// Возвращает { goToSection, goHome } — обработчики для onClick ссылок.
export default function useSectionNav(onNavigate) {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const goToSection = (id) => (e) => {
    if (e) e.preventDefault();
    if (onNavigate) onNavigate();
    if (location.pathname === "/") {
      scrollTo(id);
    } else {
      navigate("/#" + id);
    }
  };

  const goHome = (e) => {
    if (e) e.preventDefault();
    if (onNavigate) onNavigate();
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  return { goToSection, goHome };
}
